export default "__VITE_ASSET__CvD$YhsA__"